import photo1 from './project17-1.png';
import photo2 from './project17-2.png';
import photo3 from './project17-3.png';
import photo4 from './project17-4.png';
import photo5 from './project17-5.png';
import photo6 from './project17-6.png';
import photo7 from './project17-7.png';

const project17 = {
  id: 17,
  name: 'GiftU(기프트유)',
  team: [
    {
      position: 'FrontEnd Developer',
      names: '성혜린 조아령 이승진 이찬희',
    },
    {
      position: 'BackEnd Developer',
      names: '유효주 이여진 정지은',
    },
    {
      position: 'UXUI Designer',
      names: '양희연',
    },
  ],
  about:
    '"진짜 선물"을 위한 선물 펀딩 서비스, GiftU \n처치 곤란 카페 기프티콘 대신, 원하는 선물을 받을 수 있다면? 가격 부담 없이, 진심을 담아 선물하고 싶다면? GiftU에서 선물 펀딩을 열어 보세요! 하나의 펀딩에 선물을 여러 개 추가하여 달성 여부와 상관없이 모금액 이하의 최고가 선물을 받아요. 축하 메시지와 선물 후기를 주고받으며 소중한 추억을 쌓아봐요.',
  links: {
    website: 'https://gift-u.netlify.app',
    github: 'https://github.com/EFUB-GeumJaSsi',
  },
  photos: [photo1, photo2, photo3, photo4, photo5, photo6, photo7],
};

export default project17;
